export const fmt = (date) => {
  if (!date) return '—';
  return new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};
export const fmtDateTime = (date) => {
  if (!date) return '—';
  return new Date(date).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};
export const fmtCurrency = (amount, currency = 'EGP') => {
  if (amount === undefined || amount === null) return '—';
  return Number(amount).toLocaleString('en-EG') + ' ' + currency;
};
export const statusColor = (status) => {
  const map = {
    'Draft': { color: '#5F5E5A', bg: '#F1EFE8' },
    'Pending PM Review': { color: '#854F0B', bg: '#FAEEDA' },
    'Submitted to Accountant': { color: '#185FA5', bg: '#E6F1FB' },
    'Returned by Accountant': { color: '#BA7517', bg: '#FFF3CD' },
    'Returned by Managing Director': { color: '#BA7517', bg: '#FFF3CD' },
    'Pending Managing Director Approval': { color: '#534AB7', bg: '#EEEDFE' },
    'Rejected by Project Manager': { color: '#A32D2D', bg: '#FCEBEB' },
    'Rejected by Accountant': { color: '#A32D2D', bg: '#FCEBEB' },
    'Rejected by Managing Director': { color: '#A32D2D', bg: '#FCEBEB' },
    'Approved for Payment': { color: '#3B6D11', bg: '#EAF3DE' },
    'Exported for Banking': { color: '#085041', bg: '#E1F5EE' },
  };
  return map[status] || { color: '#888', bg: '#eee' };
};
export const roleLabel = (role) => {
  const map = { pm: 'Project Manager', accountant: 'Accountant', md: 'Managing Director', beneficiary: 'Beneficiary' };
  return map[role] || role;
};
export const SUPABASE_URL = 'https://pcalgasfnvmabmcymlhj.supabase.co';
export const fileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return SUPABASE_URL + '/storage/v1/object/public/payment-docs/' + path;
};
export const fileName = (path) => {
  if (!path) return '';
  const parts = path.split('/').pop().split('_');
  // Strip timestamp prefix, and random suffix if present (uploads/TIMESTAMP_RAND_name.pdf)
  if (parts.length > 2 && /^[a-z0-9]{4}$/.test(parts[1])) return parts.slice(2).join('_');
  return parts.length > 1 ? parts.slice(1).join('_') : parts[0];
};
